<template>
  <base-state-town-dialog
    :title="'house.param.town.title' | i18n"
    :subtitle="'house.param.town.subtitle' | i18n"
    :description="'house.param.town.description' | i18n"
    v-model="town" />
</template>


<script>
  import Vue from 'vue'
  import BaseStateTownDialog from "./BaseStateTownDialog"
  import townService from "../../api/townService";

  export default {
    computed: {
      town: {
        get() {
          return this.$store.state.houseParams.town
        },
        set(town) {
          this.$store.commit('houseParams/SET_TOWN', town)
        }
      }
    },

    created() {
      if(this.town == null) {
        this.$store.commit('houseParams/SET_TOWN', townService.getTownByCode('837'))
      }
    },

    components: {
      BaseStateTownDialog
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/components/dialog/HouseStateTownDialog.vue